// extracted by mini-css-extract-plugin
export var ButtonCollapse = "ButtonCollapse-module--ButtonCollapse--2oZb5";
export var ButtonCollapse__open = "ButtonCollapse-module--ButtonCollapse__open--1Gl6V";
export var open1 = "ButtonCollapse-module--open1--1eaL6";
export var open2 = "ButtonCollapse-module--open2--2XvGR";
export var ButtonCollapse__close = "ButtonCollapse-module--ButtonCollapse__close--dgs_I";
export var close1 = "ButtonCollapse-module--close1--3jXcU";
export var close2 = "ButtonCollapse-module--close2--3bAm_";